module.exports = {
  TextWithAudio: require('./components/TextWithAudio').default,

  Text: require('./sp-templates/Text/Text').default,
  Image: require('./sp-templates/Image/Image').default,
  ImageTextShort: require('./sp-templates/ImageTextShort/ImageTextShort').default,
  ImageTextLong: require('./sp-templates/ImageTextLong/ImageTextLong').default,
  Audio: require('./sp-templates/Audio/Audio').default,
  Music: require('./sp-templates/Music/Music').default,
  Video: require('./sp-templates/Video/Video').default,
  Slideshow: require('./sp-templates/Slideshow/Slideshow').default,
  IndexSingle: require('./sp-templates/IndexSingle/IndexSingle').default,
  IndexDual: require('./sp-templates/IndexDual/IndexDual').default,

  TaskTemplate: require('./sp-base-templates/TaskTemplate').default,

  QuestionShort: require('./sp-templates/QuestionShort/QuestionShort').default,
  QuestionLong: require('./sp-templates/QuestionLong/QuestionLong').default,
  QuestionImage: require('./sp-templates/QuestionImage/QuestionImage').default,
  QuestionImageText: require('./sp-templates/QuestionImageText/QuestionImageText').default,
  QuestionAudio: require('./sp-templates/QuestionAudio/QuestionAudio').default,
  QuestionVideo: require('./sp-templates/QuestionVideo/QuestionVideo').default,
  QuestionCloze: require('./sp-templates/QuestionCloze/QuestionCloze').default,

  AnswerText: require('./sp-templates/AnswerText/AnswerText').default,
  AnswerImage: require('./sp-templates/AnswerImage/AnswerImage').default,
  AnswerTextImage: require('./sp-templates/AnswerTextImage/AnswerTextImage').default,
  AnswerAudio: require('./sp-templates/AnswerAudio/AnswerAudio').default,
  AnswerFactOrFiction: require('./sp-templates/AnswerFactOrFiction/AnswerFactOrFiction').default,
  AnswerSpeak: require('./sp-templates/AnswerSpeak/AnswerSpeak').default,
  AnswerTextSelection: require('./sp-templates/AnswerTextSelection/AnswerTextSelection').default,
  AnswerDualOrder: require('./sp-templates/AnswerDualOrder/AnswerDualOrder').default,
  AnswerTextInput: require('./sp-templates/AnswerTextInput/AnswerTextInput').default,

  withAnswerEntered: require('./components/AnswerEnteredProvider').default,
  withClozeHandler: require('./components/HandleClozeProvider').default
};